import TablaPaginada from "components/comun/TablaPaginada";
import { useAuth } from "context/AuthProvider";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, Input, Row, UncontrolledDropdown } from "reactstrap";
import { apiEmpleadosService } from "services/apiEmpleadosService";
import { apiexportacionService } from "services/apiExportacionService";
import FiltroEmpleados from "./FiltroEmpleados";

const ListEmpleados = (props) => {
  const {empresa} = useAuth()
  const [mostrarBajas, setMostrarBajas]= useState(false)

  

  const handleHorarioChange  = async (empleadoId, newHorarioId) =>{
    const updatedEmpleados = props.empleados.map((empleado) =>
      empleado.id === empleadoId ? { ...empleado, horarioId: newHorarioId } : empleado
    );
    
    props.setEmpleados(updatedEmpleados);
   
    await apiEmpleadosService.updateEmpleadoHorario(empresa.id, empleadoId, newHorarioId)
  }

  const handleDescargarLOPD = async (empleadoId) =>{
    await apiexportacionService.getLopd(empresa.id, empleadoId)
  } 

  const handleMostrarBaja = () =>{
    props.handleMostrarBaja();
    setMostrarBajas(!mostrarBajas)
  }

  const cabecera = (
    <>
      <th scope="col">Empleado</th>
      <th scope="col">Departamento</th>
      <th scope="col">Centro</th>
      <th scope="col">Horario</th>
      <th scope="col">Menu</th>
      <FiltroEmpleados horarios={props.horarios} setHorarioId={props.setHorarioId} departamentos={props.departamentos} setDepartamentoId={props.setDepartamentoId} centros={props.centros} setCentroId={props.setCentroId} order={props.order} setOrder={props.setOrder} ></FiltroEmpleados>
    </>
  );

  const datos = (
    <>
      {props.empleados.map((empleado) => (
        <tr key={empleado.id} className={empleado.fechaBaja!=='' & empleado.fechaBaja <= new Date().toISOString().split('T')[0] ?'text-red':''}>
          <td>
            {empleado.apellidos}, {empleado.nombre}
          </td>
          <td>{empleado.departamento}</td>
          <td>{empleado.centro}</td>
          <td>
            <Input
              type="select"
              value={empleado.horarioId}
              onChange={(e) => handleHorarioChange(empleado.id, e.target.value)}
            >
              {props.horarios.map((horario) => (
                <option key={horario.id} value={horario.id}>
                  {horario.titulo}
                </option>
              ))}
            </Input>
          </td>
          <td>
            <UncontrolledDropdown>
              <DropdownToggle
                className="btn-icon-only"
                href=""
                role="button"
                size="sm"
                color=""
                onClick={(e) => e.preventDefault()}
              >
                <i className="fas fa-ellipsis-v" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <Link to={`/admin/empleados/detalle/${empleado.id}`}>
                  <DropdownItem>Ver detalle</DropdownItem>
                </Link>
                <Link to={`/admin/empleados/empleado/${empleado.id}`}>
                  <DropdownItem>Editar</DropdownItem>
                </Link>

                <Link to={`/admin/empleados/empleado/${empleado.id}/fichajes`}>
                  <DropdownItem>Ver fichajes</DropdownItem>
                </Link>
                <DropdownItem onClick={() => handleDescargarLOPD(empleado.id)}>
                  Clausulas LOPD
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </td>
        </tr>
      ))}
    </>
  );

  return (
    <>
      <Card className="shadow">
        <CardHeader className="border-0">
          <Row>
            <Col>
              <h3 className="mb-0">Empleados: </h3>
            </Col>

            <Col className="text-right">
             {" "}
             <Button className="btn btn-primary" onClick={handleMostrarBaja}>
                {mostrarBajas ? "Ocultar " : "Mostrar "}empleados dados de baja
              </Button>
              <Link className="btn btn-primary" to="add">
                Añadir
              </Link>
            </Col>
          </Row>
        </CardHeader>
        
        <TablaPaginada
          titulo="Empleados"
          cabecera={cabecera}
          datos={datos}
          currentPage={props.currentPage}
          totalPage={props.totalPage}
          setCurrentPage={props.setCurrentPage}
        ></TablaPaginada>     
      </Card>
    </>
  );
};

export default ListEmpleados;

